import { Popover } from '@frontend/legacy-components';

import { SelectContextProvider, SelectContextValue } from './SelectContext';
import { SelectStylesProvider, type SelectStyles } from './SelectStylesContext';

export type SelectWrapperProps = React.PropsWithChildren<{
  isOpen: boolean;
  inputRef: React.MutableRefObject<HTMLInputElement | null>;
  selectStyles: SelectStyles;
  selectContextValue: SelectContextValue;
  /** When true, menu width matches the control. */
  matchWidth?: boolean;
}>;

export const SelectWrapper = ({
  isOpen,
  inputRef,
  selectStyles,
  selectContextValue,
  children,
  matchWidth = true,
}: SelectWrapperProps) => {
  return (
    <SelectContextProvider value={selectContextValue}>
      <Popover
        isOpen={isOpen}
        closeOnBlur={false}
        initialFocusRef={inputRef}
        hasArrow={false}
        gutter={0}
        matchWidth={matchWidth}
        modifiers={[
          {
            name: 'unsetMinWidth',
            enabled: true,
            phase: 'beforeWrite',
            fn({ state }) {
              state.styles.popper.minWidth = 'unset';
            },
          },
        ]}
      >
        <SelectStylesProvider value={selectStyles}>
          {children}
        </SelectStylesProvider>
      </Popover>
    </SelectContextProvider>
  );
};
